import { slugify } from '@lyearn/core/utils/slugify';

const routes = {
  PublicCertificate: (sharedId: string) => `/certificates/${sharedId}`,
  PublicMicroLearning: (name: string, publicId: string) =>
    `/micro-learning/${slugify(name)}-${publicId}`,
};

export const routeKey = {
  PublicCertificate: 'PublicCertificate',
};

export default routes;
